import {
  OfferFromEmailMesssage,
  OrderIdentification,
  TokenForUnlogedClient,
} from "../types/session-service";
import { LoginResponsePayload } from "./account/login/types";

import {
  ClientData,
  OperatorData,
  SubcontractorData,
} from "./users/get-logged/types";
import {
  GetAllWarehouses,
  GetAllWarehousesPayload,
  WarehousesContractors,
} from "./warehouses/get-all/types";

export default class SessionService {
  static setUser(user: LoginResponsePayload) {
    return localStorage.setItem("UserAuth", JSON.stringify(user));
  }

  static getUser() {
    return JSON.parse(localStorage.getItem("UserAuth") || "null");
  }
  static isUserSet() {
    return JSON.parse(localStorage.getItem("UserAuth") || "false");
  }

  static setWarehousesList(warehousesList: GetAllWarehouses[]) {
    return localStorage.setItem(
      "WarehousesList",
      JSON.stringify(warehousesList)
    );
  }
  static getWarehousesList() {
    return JSON.parse(localStorage.getItem("WarehousesList") || "null");
  }

  static setOrder(order: any) {
    return localStorage.setItem("Order", JSON.stringify(order));
  }
  static getOrder() {
    return JSON.parse(localStorage.getItem("Order") || "null");
  }
  static clearOrder() {
    localStorage.removeItem("Order");
  }
  static isOrderSet() {
    return JSON.parse(localStorage.getItem("Order") || "false");
  }

  //For
  static setOrderIdentification(order_identification: OrderIdentification) {
    return localStorage.setItem(
      "OrderIdentification",
      JSON.stringify(order_identification)
    );
  }
  static getOrderIdentification() {
    return JSON.parse(localStorage.getItem("OrderIdentification") || "null");
  }
  static clearOrderIdentification() {
    localStorage.removeItem("OrderIdentification");
  }

  static setSubcontractors(subcontractors: WarehousesContractors[]) {
    return localStorage.setItem(
      "Subcontractors",
      JSON.stringify(subcontractors)
    );
  }
  static getSubcontractors() {
    return JSON.parse(localStorage.getItem("Subcontractors") || "null");
  }

  static setLoggedUserData(
    userData: OperatorData | SubcontractorData | ClientData
  ) {
    return localStorage.setItem("LoggedUsersData", JSON.stringify(userData));
  }
  static getLoggedUserData() {
    return JSON.parse(localStorage.getItem("LoggedUsersData") || "null");
  }
  static clearLoggedUserData() {
    localStorage.removeItem("LoggedUsersData");
  }

  static clearUserSession() {
    localStorage.removeItem("UserAuth");
  }
  static clearSessionStorage() {
    localStorage.clear();
    sessionStorage.clear();
  }

  // for offer view for unloged Client
  static setTokenForUnlogedClient(token: TokenForUnlogedClient) {
    return localStorage.setItem("Token24h", JSON.stringify(token));
  }
  static getTokenForUnlogedClient() {
    return JSON.parse(localStorage.getItem("Token24h") || "null");
  }
  static clearTokenForUnlogedClient() {
    localStorage.removeItem("Token24h");
  }

  //protect dublicate generate offer
  static setOrderNumber(orderNumber: string) {
    return localStorage.setItem("OrderNumber", JSON.stringify(orderNumber));
  }
  static getOrderNumber() {
    return JSON.parse(localStorage.getItem("OrderNumber") || "null");
  }
  static clearOrderNumber() {
    localStorage.removeItem("OrderNumber");
  }

  //offer-view from email
  static setViewOffer(emailMessage: OfferFromEmailMesssage) {
    return localStorage.setItem("OfferFromEmail", JSON.stringify(emailMessage));
  }
  static getViewOffer() {
    return JSON.parse(localStorage.getItem("OfferFromEmail") || "null");
  }
  static clearViewOffer() {
    localStorage.removeItem("OfferFromEmail");
  }
  //offer-view from email

  static setFinalOfferForAccepance(emailMessage: OfferFromEmailMesssage) {
    return localStorage.setItem(
      "FinalOfferForAccepance",
      JSON.stringify(emailMessage)
    );
  }
  static getFinalOfferForAccepance() {
    return JSON.parse(localStorage.getItem("FinalOfferForAccepance") || "null");
  }
  static clearFinalOfferForAccepance() {
    localStorage.removeItem("FinalOfferForAccepance");
  }

  static setOfferSubcontractorView(emailMessage: OfferFromEmailMesssage) {
    return sessionStorage.setItem(
      "OfferSubcontractorView",
      JSON.stringify(emailMessage)
    );
  }
  static getOfferSubcontractorView() {
    return JSON.parse(
      sessionStorage.getItem("OfferSubcontractorView") || "null"
    );
  }
  static clearOfferSubcontractorView() {
    sessionStorage.removeItem("OfferSubcontractorView");
  }
}
